import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import EmergencyTypesList from './pages/EmergencyTypesList';
import EmergencyTypeDetail from './pages/EmergencyTypeDetail';
import CategoriesList from './pages/CategoriesList';
import CategoryDetail from './pages/CategoryDetail';
import ProductDetail from './pages/ProductDetail';
import BestBuys from './pages/BestBuys';
import Wizard from './pages/Wizard';
import About from './pages/About';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/noodsituaties" element={<EmergencyTypesList />} />
            <Route path="/noodsituaties/:slug" element={<EmergencyTypeDetail />} />
            <Route path="/categorieen" element={<CategoriesList />} />
            <Route path="/categorieen/:slug" element={<CategoryDetail />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/beste-keuzes" element={<BestBuys />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/over-ons" element={<About />} />
            <Route path="/gids" element={<BlogList />} />
            <Route path="/gids/:slug" element={<BlogPost />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
